var CompareValidation = /** @class */ (function () {
    function CompareValidation() {
    }
    CompareValidation.prototype.validate = function (parameters, object) {
        var operation = parameters.Operation != null ? parameters.Operation : parameters.operation;
        var otherPropertyAccessor = parameters.OtherProperty != null ? parameters.OtherProperty : parameters.otherProperty;
        var propertyAccessor = parameters.Property != null ? parameters.Property : parameters.property;
        switch (operation) {
            case Opration.Equal:
                return object[otherPropertyAccessor] === object[propertyAccessor];
            case Opration.GreaterThan:
                return object[otherPropertyAccessor] < object[propertyAccessor];
            case Opration.GreaterThanOrEqual:
                return object[otherPropertyAccessor] <= object[propertyAccessor];
            case Opration.LessThan:
                return object[otherPropertyAccessor] > object[propertyAccessor];
            case Opration.LessThanOrEqual:
                return object[otherPropertyAccessor] >= object[propertyAccessor];
            default:
                return false;
        }
    };
    CompareValidation.prototype.canValidate = function (claims) {
        return true;
    };
    return CompareValidation;
}());
export { CompareValidation };
export var Opration;
(function (Opration) {
    Opration[Opration["Equal"] = 0] = "Equal";
    Opration[Opration["GreaterThan"] = 1] = "GreaterThan";
    Opration[Opration["GreaterThanOrEqual"] = 2] = "GreaterThanOrEqual";
    Opration[Opration["LessThan"] = 3] = "LessThan";
    Opration[Opration["LessThanOrEqual"] = 4] = "LessThanOrEqual";
})(Opration || (Opration = {}));
